import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var container = /*#__PURE__*/css("height:140px;background-size:cover;background-position:center;display:flex;flex-direction:column;justify-content:center;align-items:center;", media('>=tablet'), "{height:408px;justify-content:flex-end;gap:24px;}");
export var titles = {
  name: "1j99v99",
  styles: "display:flex;flex-direction:column;width:100%;gap:4px;"
};